import { render, staticRenderFns } from "./EditSubjectData.vue?vue&type=template&id=44437072&scoped=true&"
import script from "./EditSubjectData.vue?vue&type=script&lang=js&"
export * from "./EditSubjectData.vue?vue&type=script&lang=js&"
import style0 from "./EditSubjectData.vue?vue&type=style&index=0&id=44437072&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44437072",
  null
  
)

export default component.exports